// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Blank-module--cls1--12n30","cls2":"Blank-module--cls2--2N7xp Blank-module--cls1--12n30"};